import './specimen-edit-screen.scss'

import { defineComponent } from 'vue';
import { faCheck, faEdit, faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { SpecimenResource } from '@skinsoft/types'
import { SpecimenRecordMask } from '@skinsoft/record-mask-configs'

import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import { SAVE_GENERIC_EDIT_SCREEN } from '@skinsoft/bus'
import { GenericEditScreen } from '../../generic/generic-edit-screen'
import { EntityEditScreenController } from '@skinsoft/view-controller'
import { SpecimenDataStore } from '@skinsoft/entity'
import { SpecimenEditScreenHeader } from '@skinsoft/entity-ui/src/specimen'

declare const OFFLINE_DISABLED_MASK_FIELDS: { entityId: string, message?: string }[]

export const SpecimenEditScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sGenericEditScreen: GenericEditScreen,
        sSpecimenEditScreenHeader: SpecimenEditScreenHeader,
    },
    props: {
        specimenId: {
            type: String
        },
        headerTitle: {
            type: String,
        },
        navigateBackRoute: {
            type: String
        },
    },
    template: require('./specimen-edit-screen.html'),
    data() {
        return {
            recordMasks: [SpecimenRecordMask],
            // @ts-ignore
            viewController: null as EntityEditScreenController<SpecimenResource> | null,

            canEdit: true,
            forceReadonly: true,
            disabledMaskFields: [] as { entityId: string, message?: string }[],
        }
    },
    computed: {
        isReady() {
            return this.viewController !== null
        },
        isMainButtonClickable() {
            return this.canEdit || this.forceReadonly
        },
        buttonLabel() {
            return this.forceReadonly ?
                this.$t('editItemScreen.editButton') : this.$t('editItemScreen.confirmButton')
        },
        buttonIcon() {
            if (this.isMainButtonClickable) {
                return this.forceReadonly ?
                    faEdit : faCheck
            } else {
                return faCircleNotch
            }
        },
        buttonColor() {
            return this.forceReadonly ?
                "" : "validate-color"
        },
    },
    methods: {
        onMainButtonClick() {
            if (this.canEdit) {
                this.forceReadonly = !this.forceReadonly;
                if (this.forceReadonly) {
                    this.emitOnBus(SAVE_GENERIC_EDIT_SCREEN)
                }
            } else if (this.forceReadonly) {
                this.forceReadonly = !this.forceReadonly
            }
        },
    },
    mounted() {
        // @ts-ignore
        this.viewController = new EntityEditScreenController<SpecimenDataStore>(this.$specimenDataStore)

        this.disabledMaskFields = OFFLINE_DISABLED_MASK_FIELDS.map(field => ({
            ...field,
            message: field.message ? this.$t(field.message) as string : undefined,
        }))
    },
})
